<template>
  <ValidationObserver
      ref="observer"
      class="transition duration-500 ease-in-out transform w-full"
      style="transition: all 1s !important"
      tag="form"
      @submit.prevent="submit()"
  >
    <div class="w-full flex py-5 px-5">
      <v-card class="mx-auto w-full" flat max-height="auto" max-width="1000">
        <div class="flex flex-wrap my-6 mx-6 mb-6">
          <div class="w-full px-3 mb-6 md:mb-0 required">
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2"
            >Old Password</label
            >
            <validation-provider v-slot="{ errors }" rules="required">
              <div class="input-icons">
                <input
                    v-if="showOldPassword"
                    v-model="changePassword.oldPassword"
                    class="
                  input-field
                  shadow
                  appearance-none
                  border
                  rounded
                  py-2
                  px-3
                  text-gray-700
                  leading-tight
                  focus:outline-none focus:shadow-outline"
                    name="oldPassword"
                    placeholder="******************"
                    style="background: whitesmoke"
                    type="text"
                />
                <input
                    v-else
                    v-model="changePassword.oldPassword"
                    class="
                  input-field
                  shadow
                  appearance-none
                  border
                  rounded
                  py-2
                  px-3
                  text-gray-700
                  leading-tight
                  focus:outline-none focus:shadow-outline"
                    name="oldPassword"
                    placeholder="******************"
                    style="background: whitesmoke"
                    type="password"
                />

                <a class="button" @click="toggleOldShow()">
                  <v-icon v-if="showOldPassword">
                    mdi-eye-off
                  </v-icon>
                  <v-icon v-else>
                    mdi-eye
                  </v-icon>
                </a>
              </div>
              <span class="text-gray-600 text-xs italic text-red-600">{{
                  errors[0]
                }}</span>
            </validation-provider>
          </div>
          <div class="w-full px-3 mb-6 md:mb-0 required">
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2"
            >New Password</label
            >
            <validation-provider
                v-slot="{ errors }"
                rules="required"
                vid="confirm"
            >
              <div class="input-icons">
                <input
                    v-if="showPassword"
                    v-model="changePassword.newPassword"
                    class="
                  input-field
                  shadow
                  appearance-none
                  border
                  rounded
                  py-2
                  px-3
                  text-gray-700
                  leading-tight
                  focus:outline-none focus:shadow-outline"
                    name="newPassword"
                    placeholder="******************"
                    style="background: whitesmoke"
                    type="text"
                />
                <input
                    v-else
                    v-model="changePassword.newPassword"
                    class="
                  input-field
                  shadow
                  appearance-none
                  border
                  rounded
                  py-2
                  px-3
                  text-gray-700
                  leading-tight
                  focus:outline-none focus:shadow-outline"
                    name="newPassword"
                    placeholder="******************"
                    style="background: whitesmoke"
                    type="password"
                />

                <a class="button" @click="toggleShow()">
                  <v-icon v-if="showPassword">
                    mdi-eye-off
                  </v-icon>
                  <v-icon v-else>
                    mdi-eye
                  </v-icon>
                </a>
              </div>
              <span class="text-gray-600 text-xs italic text-red-600">{{
                  errors[0]
                }}</span>
            </validation-provider>
          </div>
          <div class="w-full px-3 mb-6 md:mb-0 required">
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2"
            >Confirm Password
            </label>
            <validation-provider
                v-slot="{ errors }"
                rules="required|confirmed:confirm"
            >
              <div class="input-icons">
                <input
                    v-if="showConfirmPassword"
                    v-model="confirmPassword"
                    class="
                  input-field
                  shadow
                  appearance-none
                  border
                  rounded
                  py-2
                  px-3
                  text-gray-700
                  leading-tight
                  focus:outline-none focus:shadow-outline"
                    name="confrim"
                    placeholder="******************"
                    style="background: whitesmoke"
                    type="text"
                />
                <input
                    v-else
                    v-model="confirmPassword"
                    class="
                  input-field
                  shadow
                  appearance-none
                  border
                  rounded
                  py-2
                  px-3
                  text-gray-700
                  leading-tight
                  focus:outline-none focus:shadow-outline"
                    name="confrim"
                    placeholder="******************"
                    style="background: whitesmoke"
                    type="password"
                />

                <a class="button" @click="toggleConfirmShow()">
                  <v-icon v-if="showConfirmPassword">
                    mdi-eye-off
                  </v-icon>
                  <v-icon v-else>
                    mdi-eye
                  </v-icon>
                </a>
              </div>
              <span class="text-gray-600 text-xs italic text-red-600">{{
                  errors[0]
                }}</span>
            </validation-provider>
          </div>
          <div class="flex flex-wrap my-6 mx-6 mb-6">
            <div class="w-full">
              <!-- <button
            @click="$emit('close')"
            class="float-left shadow focus:shadow-outline focus:outline-none font-bold py-2 px-4 rounded"
            type="button"
            >Cancel</button>-->
              <v-btn
                  :loading="loading"
                  class="float-right shadow bg-teal-600 hover:bg-teal-600 focus:shadow-outline focus:outline-none text-white font-bold py-2 px-4 rounded"
                  color="success"
                  type="button"
                  @click="submit()"
              >
                Save
              </v-btn>
            </div>
          </div>
        </div>
      </v-card>
    </div>
  </ValidationObserver>
</template>

<script>
import {extend, ValidationObserver, ValidationProvider} from "vee-validate";
import {confirmed, required} from "vee-validate/dist/rules";
import {LoginService} from "./login.service";

extend("required", {
  ...required,
  message: "This field is required",
});

extend("confirmed", {
  ...confirmed,
  message: "Password doesn't match",
});

export default {
  name: "ChangePassword",
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      confirmPassword: null,
      changePassword: {
        oldPassword: null,
        newPassword: null,
      },
      loading: false,
      showPassword: false,
      showConfirmPassword: false,
      showOldPassword: false,
    };
  },
  computed: {
    buttonLabel() {
      return this.showPassword ? "Hide" : "Show";
    },
  },
  methods: {
    toggleShow() {
      this.showPassword = !this.showPassword;
    },
    toggleConfirmShow() {
      this.showConfirmPassword = !this.showConfirmPassword;
    },
    toggleOldShow() {
      this.showOldPassword = !this.showOldPassword;
    },
    async submit() {
      this.loading = true;
      if (!(await this.$refs.observer.validate())) return;
      this.$refs.observer.validate();

      const res = await LoginService.changePassword(this.changePassword);
      switch (res.data.status) {
        case 200:
          this.$toast.success(res.data.message);
          this.loading = false;
          localStorage.removeItem("token");
          localStorage.removeItem("user");
          this.$router.push("/login");
          break;
        case 500:
          this.$toast.error(res.data.message);
          this.loading = false;
          break;
        default:
          this.$toast.error("Unable to change password, please try again");
          this.loading = false;
      }
    },
  },
};
</script>

<style scoped>

.input-icons {
  width: 100%;
  margin-bottom: 10px;
  box-shadow: 0 1px 3px 0 rgb(0 0 0 / 10%), 0 1px 2px 0 rgb(0 0 0 / 6%);
  border-radius: 4px !important;
  background-color: whitesmoke;
}

/* .input-icons i {
  position: absolute;
} */
.button {
  padding: 10px;
  min-width: 40px;
}

.input-field {
  width: 82%;
  padding: 10px;
}
</style>
